import { InfaceEnv } from '@inface-sdk/common';
import { createSdkApis } from './interface';
var inpayWebSdk = createSdkApis();
if (InfaceEnv.isBrowser()) {
  var _window$inface;
  if (!window.inface) {
    window.inface = {};
  }
  var locale = (_window$inface = window.inface) === null || _window$inface === void 0 || (_window$inface = _window$inface.auth) === null || _window$inface === void 0 ? void 0 : _window$inface.locale;
  if (locale && locale.split('-').length <= 1) {
    // edget browser locale value is just 'ko'
    // country 값을 selector에서 받아온 값으로 사용하도록 한다.

    // TODO event 기반으로 변경
    var countrySetIntervalHandler = setInterval(function () {
      var _window$inface2;
      var country = (_window$inface2 = window.inface) === null || _window$inface2 === void 0 || (_window$inface2 = _window$inface2.auth) === null || _window$inface2 === void 0 ? void 0 : _window$inface2.country;
      if (country) {
        clearInterval(countrySetIntervalHandler);
        InfaceEnv.setupEnv({
          locale: "".concat(locale, "-").concat(country) || window.navigator.language || 'en-us'
        });
      }
    }, 200);
  } else {
    InfaceEnv.setupEnv({
      locale: locale || window.navigator.language || 'en-us'
    });
  }
  window._inpayConnector = inpayWebSdk;
  window.InpayConnector = window._inpayConnector;
  window.inface.inpay = window._inpayConnector;
}
export { inpayWebSdk };
export default inpayWebSdk;